export const url1: string[] = [
  '/assets/exihibition1/expo1.jpg',
  '/assets/exihibition1/oameni.jpg',
  '/assets/exihibition1/boyz.jpeg',
  '/assets/exihibition1/lup.jpeg',
  '/assets/exihibition1/oameni4.jpeg',
  '/assets/exihibition1/mom.jpeg',
  '/assets/exihibition1/oameni2.png',
  '/assets/exihibition1/oamnei3.jpg',
  '/assets/exihibition1/picturi1.jpg',
];
export const url2: string[] = [
  '/assets/exhibition2/castigator.jpg',
  '/assets/exhibition2/oameni.jpg',
  '/assets/exhibition2/oameni2.jpg',
  '/assets/exhibition2/picturi1.jpg',
  '/assets/exhibition2/picturi2.png',
  '/assets/exhibition2/picturi3.png',
  '/assets/exhibition2/people.jpeg',
  '/assets/exhibition2/premiu.jpg',
  '/assets/exhibition2/steve.jpg',
  '/assets/exhibition2/boyz.jpeg',
  '/assets/exhibition2/family.jpeg',
  '/assets/exhibition2/grandparents.jpeg',
];
export const url3: string[] = [
  '/assets/exhibition3/1.jpg',
  '/assets/exhibition3/1-1.jpg',
  '/assets/exhibition3/5.jpg',
  '/assets/exhibition3/8.jpg',
  '/assets/exhibition3/9.jpg',
  '/assets/exhibition3/4.jpg',
  '/assets/exhibition3/6.jpg',
  '/assets/exhibition3/7.jpg',
  '/assets/exhibition3/2-1.jpg',
];
export const url4: string[] = [
  '/assets/exhibition4/poze/Lupul Creativ-2-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-4-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-9-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-21-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-22-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-24-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-32-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-33-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-42-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-43-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-45-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-66-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-67-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-71-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-72-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-85-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-96-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-111-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-120-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-121-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-122-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-125-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-131-min.jpg',
  '/assets/exhibition4/poze/Lupul Creativ-132-min.jpg',
];
export const url5: string[] = [
  '/assets/exhibition5/poze/Lupul Creativ - expozitie-104.JPG',
  '/assets/exhibition5/poze/Lupul Creativ - expozitie-106.JPG',
  '/assets/exhibition5/poze/Lupul Creativ - expozitie-152.JPG',
  '/assets/exhibition5/poze/Lupul Creativ - expozitie-93.JPG',
  '/assets/exhibition5/poze/Lupul Creativ - expozitie-65.JPG',
  '/assets/exhibition5/poze/Lupul Creativ - expozitie-66.JPG',
  '/assets/exhibition5/poze/Lupul Creativ - expozitie-75.JPG',
  '/assets/exhibition5/poze/Lupul Creativ - expozitie-115.JPG',
  '/assets/exhibition5/poze/Lupul Creativ - expozitie-135.JPG',
  '/assets/exhibition5/poze/Lupul Creativ - expozitie-41.JPG',
  '/assets/exhibition5/poze/Lupul Creativ - expozitie-33.JPG',
];
